import { call, put } from "redux-saga/effects";

import { topicsApiSlice } from "api/topicsApi.slice";
import { apiFetch } from "common/utilities";
import { RequestError } from "common/utilities/requestError";
import { acceptMapShareInviteFailure, acceptMapShareInviteSuccess } from "domains/createShareSettings/actions";
import type { AcceptMapInviteDefaultAction } from "domains/createShareSettings/actionTypes";
import { fetchSharedWithMe } from "entities/topics/actions";
import { store } from "store";

export function* acceptMapInviteSaga(action: AcceptMapInviteDefaultAction) {
  try {
    const invite_token = action.meta.token;
    yield apiFetch(`topic/access/${invite_token}`);
    yield put(acceptMapShareInviteSuccess(action.meta));
    yield call(() =>
      store.dispatch(topicsApiSlice.endpoints.getTopicMetadata.initiate(undefined, { forceRefetch: true })),
    );
    yield put(fetchSharedWithMe({ offset: 0, limit: 8 }));
  } catch (error) {
    if (!(error instanceof RequestError)) return;
    yield put(
      acceptMapShareInviteFailure({ ...action.meta, isDeleted: error.status === 404, isExpired: error.status === 401 }),
    );
  }
}
